import { useMemo } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { ErrorContent } from '../components/ErrorContent'

export type DefaultInputProps = {
  name: string,
  form: Record<string, any>,
  error?: string,
  errors?: Record<string, any>,
  onChange?: (key: string, value: string) => void,
}

const useInput = (props: DefaultInputProps) => {
  const {
    name,
    form,
    error,
    errors,
    onChange
  } = props
  const { t } = useTranslation()

  const value = form ? ((typeof form[name] === 'undefined' || form[name] === null) ? '' : typeof form.name === 'boolean' ? (form[name] ? 1 : 0) : form[name]) : undefined

  const errorText = useMemo(() => {
    if (error) {
      return error
    }
    if (errors && errors[name]) {
      return typeof errors[name] === 'string' && (errors[name] as string).includes('common:') ? t(errors[name] as string) : errors[name] as string
    }
    return null
  }, [error, JSON.stringify(errors), name])

  const errorContent = useMemo(() => {
    if (errorText && errorText !== '') {
      return <ErrorContent name={name} errorText={errorText} />
    }
    return null
  }, [errorText, name])

  const onSet = (value) => {
    if (onChange) {
      onChange(name, value)
    }
  }

  return {
    value,
    errorText,
    errorContent,
    onSet
  }
}

export default useInput
